import { HawaPanel } from '../types'

import component from './table-datalog.component.vue'
import editor from './table-datalog.editor.vue'
import { Attribute, Field } from './types'

export default class TableDatalog implements HawaPanel {
  name = 'TableDatalog'
  title = 'Table Datalog'
  component = component
  editor = editor
  snapshot = {
    title: 'Table Datalog',
  }

  init = {
    attributes: {
      panelHeader: {
        show: false,
        style: {},
      },
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: true,
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      updateInterval: 3000,
      fields: [] as Field[],
      dataLoggerId: -1,
    } as Attribute,

    data: null,

    layout: { i: '1591166209124', h: 24, w: 480, x: 0, y: 0, moved: false },

    query: [],
  }
}
